import i from "../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
const s = "noopener noreferrer nofollow";
class f {
  constructor() {
    this.externalLinkEnabled = !0, this.externalLinkRel = void 0, this.externalLinkTarget = void 0, this.isInPresentationMode = !1, this.pdfDocument = void 0, this.pdfViewer = void 0;
  }
  setDocument(e) {
    this.pdfDocument = e;
  }
  setViewer(e) {
    this.pdfViewer = e;
  }
  setExternalLinkRel(e) {
    this.externalLinkRel = e;
  }
  setExternalLinkTarget(e) {
    this.externalLinkTarget = e;
  }
  setHistory() {
  }
  get pagesCount() {
    return this.pdfDocument ? this.pdfDocument.numPages : 0;
  }
  get page() {
    return i(this.pdfViewer, "PDF viewer is not initialized."), this.pdfViewer.currentPageNumber || 0;
  }
  set page(e) {
    i(this.pdfViewer, "PDF viewer is not initialized."), this.pdfViewer.currentPageNumber = e;
  }
  get rotation() {
    return 0;
  }
  set rotation(e) {
  }
  goToDestination(e) {
    return new Promise((t) => {
      i(this.pdfDocument, "PDF document not loaded."), i(e, "Destination is not specified."), typeof e == "string" ? this.pdfDocument.getDestination(e).then(t) : Array.isArray(e) ? t(e) : e.then(t);
    }).then((t) => {
      i(Array.isArray(t), `"${t}" is not a valid destination array.`);
      const n = t[0];
      new Promise((a) => {
        i(this.pdfDocument, "PDF document not loaded."), n instanceof Object ? this.pdfDocument.getPageIndex(n).then((r) => {
          a(r);
        }).catch(() => {
          i(!1, `"${n}" is not a valid page reference.`);
        }) : typeof n == "number" ? a(n) : i(!1, `"${n}" is not a valid destination reference.`);
      }).then((a) => {
        const r = a + 1;
        i(this.pdfViewer, "PDF viewer is not initialized."), i(r >= 1 && r <= this.pagesCount, `"${r}" is not a valid page number.`), this.pdfViewer.scrollPageIntoView({
          dest: t,
          pageIndex: a,
          pageNumber: r
        });
      });
    });
  }
  navigateTo(e) {
    this.goToDestination(e);
  }
  goToPage(e) {
    const t = e - 1;
    i(this.pdfViewer, "PDF viewer is not initialized."), i(e >= 1 && e <= this.pagesCount, `"${e}" is not a valid page number.`), this.pdfViewer.scrollPageIntoView({
      pageIndex: t,
      pageNumber: e
    });
  }
  addLinkAttributes(e, t, n) {
    e.href = t, e.rel = this.externalLinkRel || s, e.target = n ? "_blank" : this.externalLinkTarget || "";
  }
  getDestinationHash() {
    return "#";
  }
  getAnchorUrl() {
    return "#";
  }
  setHash() {
  }
  executeNamedAction() {
  }
  cachePageRef() {
  }
  isPageVisible() {
    return !0;
  }
  isPageCached() {
    return !0;
  }
  executeSetOCGState() {
  }
}
export {
  f as default
};
//# sourceMappingURL=LinkService.es.js.map
